import { render, staticRenderFns } from "./MyProfileBlock.vue?vue&type=template&id=6cd108ad&scoped=true&"
import script from "./MyProfileBlock.vue?vue&type=script&lang=js&"
export * from "./MyProfileBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd108ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
